<template>
    <el-dialog title="设置设备序列号" class="el-sbxlh-my-dialog" :close-on-click-modal="false" :close-on-press-escape="false" top="80px" width="800px" :visible.sync="dialogVisible">
        <div class="my-dialog-content">
          <div class="input-section">
            <div class="input-header">
                <p>
                    <span class="tip-danger-text">*</span>
                    <span class="tip-text">提示：多个序列号，逗号 , 分隔</span>
                </p>
              <el-button type="primary" size="medium" class="add-series-btn" @click="addSeriesNumber">添加设备序列号</el-button>
            </div>
            <el-input
              type="textarea"
              :rows="8"
              placeholder="多行文本，回车加载标签，换行符、中英文逗号为分割点"
              v-model="textareaValue"
               @keydown.enter.native.prevent="handleEnterKey"
              class="series-textarea"
            ></el-input>
            <div class="duplicate-tip" v-if="showDuplicateTip">
              检测到重复序列号：{{ duplicateItems.join('、') }}，不允许重复添加，请删除重复内容。
            </div>
          </div>
          <div class="display-section">
            <div class="display-header">已创建的设备序列号，已添加（{{tags.length}}）个</div>
            <div class="tags-container">
              <el-tag
                v-for="(tag, index) in tags"
                :key="index"
                closable
                @close="removeTag(index)"
                class="series-tag"
              >
                {{ tag }}
              </el-tag>
            </div>
            <!-- <div class="tag-count">共{{ tags.length }}个标签</div> -->
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="save">确定</el-button>
            <el-button type="info" plain @click="()=>{
                dialogVisible = false;
                tags = []
                duplicateItems = []
            }">取消</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { length } from 'file-loader';

export default {
    name: "setSBXLHDialog",
    data() {
        return {
            dialogVisible: false,
            textareaValue: '',
            tags: [],
            showDuplicateTip: false,
            duplicateItems: [],
            max:null
        };
    },
    components: {},
    computed: {},
    mounted() {},
    methods: {
        save(){
            if(this.tags.length!==0&&this.max!==null&&this.tags.length !== this.max){
                this.$notify({
                    title: '警告，设备数量为 '+this.max,
                    message: '设备序列号数量与设备数量不匹配，设备序列号数量应为' + this.max,
                    type: 'error'
                });
                return
            }
            this.$emit('saveSBXLH',this.tags)
            this.dialogVisible = false
           
            this.max = null
        },
        openDialog(val,max) {
           this.textareaValue = ''
            this.dialogVisible = true
            this.max = max ? max : 0
            this.tags = []
            // 解析传入的val参数并添加到tags中
            if (val) {
                // 如果val是字符串，按分隔符分割
                if (typeof val === 'string') {
                    const items = val
                        .split(/[\n\r,，]/) // 按换行符和中英文逗号分割
                        .map(item => item.trim()) // 清除每项首尾空格
                        .filter(item => item !== ''); // 过滤空项
                    
                    // 添加到标签数组，避免重复
                    items.forEach(item => {
                        if (!this.tags.includes(item)) {
                            this.tags.push(item);
                        }
                    });
                }
                // 如果val是数组，直接处理数组元素
                else if (Array.isArray(val)) {
                    val.forEach(item => {
                        const trimmedItem = String(item).trim();
                        if (trimmedItem && !this.tags.includes(trimmedItem)) {
                            this.tags.push(trimmedItem);
                        }
                    });
                }
                // 如果val是其他类型，转换为字符串处理
                else {
                    const trimmedItem = String(val).trim();
                    if (trimmedItem && !this.tags.includes(trimmedItem)) {
                        this.tags.push(trimmedItem);
                    }
                }
            }
        },
        handleEnterKey(e) {
           
            if (e.ctrlKey || e.shiftKey) {
                // ctrl+回车时，允许换行
                this.textareaValue += '\n'
                return
            }
            // 普通回车执行逻辑
            const duplicates = this.checkForDuplicates()
            if (duplicates.length > 0) {
                this.duplicateItems = duplicates
                this.showDuplicateTip = true
                return
            }
            this.processTextInput()
        },
        
        processTextInput() {
            if (!this.textareaValue.trim()) return;
            // 处理文本：按换行符、中英文逗号分割，清除每项的空格
            const items = this.textareaValue
                .split(/[\n\r,，]/) // 按换行符和中英文逗号分割
                .map(item => item.trim().slice(0, 100)) // 清除每项首尾空格
                .filter(item => item !== ''); // 过滤空项


            
            // 添加到标签数组
            items.forEach(item => {
                if (!this.tags.includes(item)) {
                    this.tags.push(item);
                }
            });
            
            // 清空输入框
            this.textareaValue = '';
            this.showDuplicateTip = false;
            this.duplicateItems = [];
        },
        
        checkForDuplicates() {
            if (!this.textareaValue.trim()) return [];
            
            const items = this.textareaValue
            .split(/[\n\r,，]/) // 按换行符和中英文逗号分割
            .map(item => {
                // 先清除首尾空格，再截断到最多100个字符
                return item.trim().slice(0, 100);
            })
            .filter(item => item !== ''); // 过滤空项（包括截断后为空的情况）
            
            const duplicates = [];
            
            // 检查当前输入内容是否有内部重复
            const itemCounts = {};
            items.forEach(item => {
                itemCounts[item] = (itemCounts[item] || 0) + 1;
            });
            
            Object.keys(itemCounts).forEach(item => {
                if (itemCounts[item] > 1) {
                    duplicates.push(item);
                }
            });
            
            // 检查是否与已添加的标签重复
            items.forEach(item => {
                if (this.tags.includes(item) && !duplicates.includes(item)) {
                    duplicates.push(item);
                }
            });
            
            return duplicates;
        },
        
        removeTag(index) {
            this.tags.splice(index, 1);
        },
        
        addSeriesNumber() {
           
            const duplicates = this.checkForDuplicates();
            if (duplicates.length > 0) {
                this.duplicateItems = duplicates;
                this.showDuplicateTip = true;
                return;
            }
            // 添加序列号按钮的处理逻辑
            this.processTextInput();
        }
    }
};
</script>
<style scoped lang="scss">
.el-sbxlh-my-dialog{
    .my-dialog-content{
    }
    .input-section {
        margin-bottom: 20px;
        
        .input-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 10px;
            .tip-danger-text{
                color: red;
            }
            .tip-text {
                color: #999;
                font-size: 12px;
            }
            
        }
        
        .series-textarea {
            margin-bottom: 10px;
        }
        
        .duplicate-tip {
            color: #F56C6C;
            font-size: 12px;
            margin-top: 5px;
        }
    }

    .display-section {
        .display-header {
            text-align: center;
            font-size: 16px;
            color: #333;
            margin-bottom: 15px;
            font-weight: 500;
        }
        
        .tags-container {
            height: 200px;
            overflow-y: auto;
            border: 2px solid #cccccc;
            border-radius: 4px;
            padding: 15px;
            background-color: #f9f9f9;
            display: flex;
            flex-wrap: wrap;
            gap: 8px;
            align-content: flex-start;
            
            .series-tag {
                margin: 0;
                background-color: #fff;
                border: 1px solid #ddd;
                color: #333;
                text-wrap: auto;
                height: auto;
            }
        }
        
        .tag-count {
            text-align: center;
            margin-top: 10px;
            color: #666;
            font-size: 14px;
        }
    }
}

</style>
<style  lang="scss">
    .el-sbxlh-my-dialog{
        .el-dialog__body{
            padding:10px;
        }
        .my-dialog-content{
            padding:0;
        }
        .el-dialog__header{
            border-bottom: 1px solid #cccccc;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/supplierCollaboration/setSBXLHDialog.vue